module.exports = __webpack_public_path__ + "img/marketresearch.c5680c6c.svg";